import Flatpickr from "stimulus-flatpickr";
import { French } from 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/flatpickr.css';

export default class extends Flatpickr {
  initialize() {
    this.config = {
      locale: French,
      altFormat: "d F Y",
      altInput: true,
      onClose: (selectedDates, dateStr, instance) => {
        if (selectedDates.length === 0) {
          // Si aucune date n'est sélectionnée, déclencher l'événement focusout
          this.element.dispatchEvent(new Event('focusout'));
        }
      }
    };
  }
}
